import { Menu } from "@headlessui/react";
import React from "react";
import { joinClasses } from "../../utils/joinClasses";
// needs updating to headless v2 so we can have dynamic positioning and proper z-index usage
export const Dropdown = ({ className, ...props }) => (React.createElement(Menu, { as: "div", className: joinClasses(["nxm-dropdown", className]), ...props }));
